import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconPlay = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M7 6v12l10-6z" }, void 0) }, void 0));
const Memo = memo(SvgIconPlay);
export default Memo;
//# sourceMappingURL=IconPlay.js.map